// src/api/fetchChatAudio.js
import { createChatRequest } from './createChatRequest';
import { parseChatResponse } from './parseChatResponse';

/**
 * Streams partial text + PCM audio + sources from the server.
 *
 * @param {Object[]} messages - Array of { role, content, sources }
 * @param {(text: string) => void} onTextChunk - callback for partial text
 * @param {(pcm: Uint8Array) => void} onAudioChunk - callback for PCM audio
 * @param {string} endpoint - Server endpoint (e.g. "/chataudio/openai")
 * @param {AbortController} [abortController]
 * @param {(Array) => void} [onSourcesChunk] - callback for an array of sources
 * @param {(Array) => void} [onActionsChunk] - callback for an array of actions
 * @param {Object} [extraOptions] - Extra options, e.g. { chatStyle: "news_summary", personal_context: "John Doe" }
 * @returns {Promise<void>}
 */
export async function fetchChatAudio(
  messages,
  onTextChunk,
  onAudioChunk,
  endpoint,
  abortController,
  onSourcesChunk,
  onActionsChunk,
  extraOptions
) {
  // Build the full request object according to ChatHistoryRequest
  const requestBody = {
    messages,
    ...(extraOptions?.personal_context && { personal_context: extraOptions.personal_context }),
    ...(extraOptions?.chatStyle && { chat_style: extraOptions.chatStyle }),
    ...(extraOptions?.chatId && { id: extraOptions.chatId }),
    ...(extraOptions?.chatId && { allowed_domains: extraOptions.allowedDomains }),
  };

  const response = await createChatRequest(
    requestBody,
    endpoint,
    abortController?.signal
  );

  return parseChatResponse(
    response,
    onTextChunk,
    onAudioChunk,
    onSourcesChunk,
    onActionsChunk
  );
}
